/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import HomeRoutes from "./HomeRoutes";
import { Switch, useLocation, Route } from "react-router-dom";
import AcceptInvitation from "./AcceptInvitation";
import ForgotPassword from "./ForgotPassword";
import DeleteAccount from "./DeleteAccount";

export function AuthPage() {
  const location = useLocation();

  return (
    <>
      {location.pathname.startsWith("/invite/") || location.pathname.startsWith("/forgot-password") || location.pathname.startsWith("/reset-password/") || location.pathname.startsWith("/delete-account") ? (
        <Switch>
          <Route path="/invite/:token" component={AcceptInvitation} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/delete-account" component={DeleteAccount} />
        </Switch>
      ) : (
        <HomeRoutes />
      )}
    </>
  );
}
